// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2n02-3MpC0v77s18hmiNbz label {\n    font-weight: normal;\n    margin-bottom: 0;\n}\n\n._1Yw8B08NwzPUtg6tA0SS1q > .form-group > label.control-label {\n    margin-bottom: 4px;\n    font-weight: 600;\n}\n\n._1Yw8B08NwzPUtg6tA0SS1q + ._1Yw8B08NwzPUtg6tA0SS1q {\n    margin-top: 18px;\n}\n", ""]);
// Exports
exports.locals = {
	"form": "_2n02-3MpC0v77s18hmiNbz",
	"question": "_1Yw8B08NwzPUtg6tA0SS1q"
};
module.exports = exports;
